import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { phonetTypes, phonetActions } = createActionsStructure('phonet', [
  { name: 'SUBSCRIBE_TO_CALL', async: true },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/PhonetActions.js